import {
  InterestsCalculatorVariant,
  QuotaRoundingMethod,
} from '../../../../../types/tariffTypes';
import { formatToOnlyPositiveScaledIntegers } from '../../../../../utils/currency';

import { InstallmentSettings, InstallmentSettingsForm } from './types';

export const DEFAULT_VALUES: InstallmentSettingsForm = {
  maxInstallments: 1,
  noInterestsInstallments: 0,
  interestCalculatorVariant: InterestsCalculatorVariant.ProrateInterest,
  quotaRoundingMethod: QuotaRoundingMethod.NotRound,
  interestRate: '',
  maxTariffDownPaymentRate: '',
  hasInterests: false,
  hasTariffDownPayment: false,
};

/**
 * El input de tasa trabaja en centésimas de punto porcentual: 0,015 (1,5 %) se
 * muestra como "1,50", que son 150 dígitos crudos. De ahí el factor 10.000.
 */
const RATE_SCALE = 10000;

const rateToInput = (rate?: number): string =>
  formatToOnlyPositiveScaledIntegers(`${Number(rate ?? 0) * RATE_SCALE}`);

const inputToRate = (value?: string): number =>
  Number(`${value ?? ''}`.replace(/\D/g, '').trim() || 0) / RATE_SCALE;

export const parseFromFetch = (
  data: InstallmentSettings,
): InstallmentSettingsForm => ({
  maxInstallments: data?.maxInstallments ?? DEFAULT_VALUES.maxInstallments,
  noInterestsInstallments:
    data?.noInterestsInstallments ?? DEFAULT_VALUES.noInterestsInstallments,
  interestCalculatorVariant:
    data?.interestCalculatorVariant ?? DEFAULT_VALUES.interestCalculatorVariant,
  quotaRoundingMethod:
    data?.quotaRoundingMethod ?? DEFAULT_VALUES.quotaRoundingMethod,
  hasInterests: !!data?.interestRate,
  hasTariffDownPayment: !!data?.maxTariffDownPaymentRate,
  interestRate: rateToInput(data?.interestRate),
  maxTariffDownPaymentRate: rateToInput(data?.maxTariffDownPaymentRate),
});

export const parseToFetch = (
  data: InstallmentSettingsForm,
): InstallmentSettings => ({
  maxInstallments: data.maxInstallments,
  interestCalculatorVariant: data.interestCalculatorVariant,
  quotaRoundingMethod: data.quotaRoundingMethod,
  interestRate: data.hasInterests ? inputToRate(data.interestRate) : 0,
  noInterestsInstallments: data.hasInterests ? data.noInterestsInstallments : 0,
  maxTariffDownPaymentRate: data.hasTariffDownPayment
    ? inputToRate(data.maxTariffDownPaymentRate)
    : 0,
});

/** El backend rechaza tasas fuera de [0, 1]; avisamos antes de mandar. */
export const hasError = ({
  interestRate,
  maxTariffDownPaymentRate,
}: InstallmentSettings): string | null => {
  if (maxTariffDownPaymentRate > 1) {
    return 'toasts.maxTariffDownPaymentError';
  }
  if (interestRate > 1) {
    return 'toasts.maxInterestRateError';
  }
  return null;
};
